import FieldRenderer, { INPUT_TYPE_MAP } from './FieldRenderer';

export default FieldRenderer;
export { INPUT_TYPE_MAP };
